const SixACLimitsContent = `


Limits and conditions for allowance of expenditure in certain cases.

6AC. [Omitted by the IT (Thirty-second Amdt.) Rules, 1999, w.e.f. 19-11-1999.]
`;

export default SixACLimitsContent;